import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { PiInfoDuotone, PiListChecksDuotone } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

export const SubmenuFinancePage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Keuangan",
    });
  }, [setHeader]);
  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
            <PiInfoDuotone
              className="card-icon tw-text-[#FF5C5C]"
              // style={{ background: "#eee" }}
            />
            <div className="card-name">Bulanan</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
            <PiInfoDuotone className="card-icon tw-text-[#FF5C5C]" />
            <div className="card-name">Non Bulanan</div>
          </div>
        </div>

        {/* <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.DEBT_BILL_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
            <PiInfoDuotone
              className="card-icon tw-text-[#FF5C5C]"
            />
            <div className="card-name">Utang</div>
          </div>
        </div> */}

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
            <PiListChecksDuotone className="card-icon" />
            <div className="card-name">Rekening Koran</div>
          </div>
        </div>
      </div>
    </div>
  );
};
